// One function, same shape as photoReviewApi.js: GET the pieces with a rejected shot.
export const getRejected = fetchResource => fetchResource({ method: 'GET', resource: 'photo-pipeline/rejected', loadingKey: 'rejected' });
